<style lang="less" scoped>
  .form-container {
    padding: 60px 0;
  }
  .title {
    font-size: 20px;
  }
  .divider {
    width: 100%;
    height: 1px;
    margin-top: 40px;
    background-color: #e9edef;
  }
  .form-section {
    padding: 40px 0 18px 0;
    border-bottom: 1px solid #e9edef;
  }
  .form-section-title {
    margin-bottom: 20px;
    color: #ff6c00;
    font-size: 15px;
  }
  .el-form-item-group {
    display: flex;
  }
  .username-input-wrapper {
    flex: 1;
    &:not(:first-of-type) {
      margin-left: 20px;
    }
  }
  .username-form-group {
    display: flex;
    justify-content: space-between;
  }
  .form-group {
    width: calc(100% - 287px);
  }
  .append-group {
    display: flex;
    align-items: center;
    width: 287px;
    padding-left: 20px;
  }
  .input-hint {
    font-size: 13px;
    color: #7965ef;
  }
  .select {
    width: 100%;
  }
  .age-group-checkbox {
    flex: 1;
    text-align: center;
  }
  .submit-button-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 60px;
  }
  .submit-button {
    width: 120px;
    height: 50px;
    font-size: 15px;
    font-weight: bold;
  }
</style>

<style lang="less">
  .sc-register-form {
    .el-form-item__content {
      display: flex;
    }
    .el-checkbox__input {
      display: none;
    }
    .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      margin: -2px;
      .el-checkbox.is-bordered {
        margin: 2px !important;
        width: calc((100% - 20px) / 5);
        // padding: 9px 20px 9px 10px;
        text-align: center;
        height: 34px !important;
      }
    }
    .el-input-group__prepend {
      width: 100px;
      background-color: #fff;
    }
    .el-input-group__append {
      background-color: #fff;
    }
    .el-radio__input {
      top: 1px;
    }
    .el-radio__label {
      vertical-align: middle;
    }
    .el-checkbox.is-bordered {
      padding: 6px 20px 10px 10px;
      height: 36px;
    }
  }
</style>

<template lang="pug">
  .form-container
    h1.title 정보입력
    .divider
    el-form.form.sc-register-form(
      :model="form",
      :rules="rules",
      :hide-required-asterisk="true",
      label-width="130px",
      label-position="left",
      ref="formRef")
      section.form-section
        h2.form-section-title 로그인 정보
        .el-form-item-group
          el-form-item.username-input-wrapper(label-width="0px", prop="id")
            el-input(placeholder="회원 아이디", v-model="form.id")
              el-button.append-button(slot="append", @click="checkDuplicate") 중복체크
          el-form-item.username-input-wrapper(label-width="0px", prop="passwd")
            el-input(type="password", placeholder="비밀번호", v-model="form.passwd")
          el-form-item.username-input-wrapper(label-width="0px", prop="passwdValidator")
            el-input(type="password", placeholder="비밀번호 확인", v-model="form.passwdValidator")
      section.form-section
        h2.form-section-title 쇼핑몰 기본 정보
        el-form-item(label="기업 명", prop="companyName")
          .form-group
            el-input.md(placeholder="기업 명", v-model="form.companyName")
        el-form-item(label="대표자 명", prop="presidentName")
          .form-group
            el-input.md(placeholder="대표자 명", v-model="form.presidentName")
        el-form-item(label="쇼핑몰 명", prop="storeName")
          .form-group
            el-input(placeholder="쇼핑몰 명", v-model="form.storeName")
        el-form-item(label="웹 도메인", prop="storeDomain")
          .form-group
            el-input(placeholder="웹 도메인", v-model="form.storeDomain", @blur="blurUrl($event, 'web')")
          .append-group
            p.input-hint http:// 및 www를 제외하고 기입
        el-form-item(label="모바일 도메인", prop="storeMobDomain")
          .form-group
            el-input(placeholder="모바일 도메인", v-model="form.storeMobDomain", @blur="blurUrl($event, 'mobile')")
          .append-group
            p.input-hint http:// 및 www를 제외하고 기입
        el-form-item(label="호스팅사", prop="hostingCode")
          .form-group
            el-select.select(placeholder="호스팅", v-model="form.hostingCode", @change="changeHosting")
              el-option(label="메이크샵", value="01")
              el-option(label="카페24", value="02")
              el-option(label="고도몰", value="03")
              el-option(label="위사몰", value="04")
              el-option(label="후이즈몰", value="05")
              el-option(label="독립몰", value="06")
              el-option(label="기타 호스팅", value="99")
          el-form-item.append-group(v-if="form.hostingCode === '99'", prop="hostingEtc")
            el-input(placeholder="직접 입력", v-model="form.hostingEtc")
        el-form-item(v-if="form.hostingCode === '99'", label="네이버 EP", prop="nvEpTotalUrl")
          .form-group
            el-input(placeholder="네이버 EP 전체 URL", v-model="form.nvEpTotalUrl")
        el-form-item(label="사업자 등록증", prop="licenseFile")
          .form-group
            sc-file-input(
              v-model="form.licenseFile"
              placeholder="사업자 등록증",
              :fileName="form.licenseFileName",
              @upload="upload")
              el-button.append-button(slot="append") 찾아보기
      section.form-section
        h2.form-section-title 쇼핑몰 속성
        el-form-item(label="구분 / 연령대", prop="shopType")
          .form-group
            el-select.select(placeholder="선택하세요", v-model="form.shopType", @change="changeShopType")
              el-option(label="여성 소호몰", value="1")
              el-option(label="남성 소호몰", value="2")
              el-option(label="브랜드몰", value="3")
          .append-group
            el-checkbox.age-group-checkbox(label="10대", border, v-model="form.ageGroup10", @change="changeAge($event, '101')")
            el-checkbox.age-group-checkbox(label="20대", border, v-model="form.ageGroup20", @change="changeAge($event, '102')")
            el-checkbox.age-group-checkbox(label="30대", border, v-model="form.ageGroup30", @change="changeAge($event, '103')")
        el-form-item(v-if="form.shopType && form.shopType !== '3'", label="스타일별 카테고리", prop="cateSeqs")
          el-checkbox-group(v-model="form.cateSeqs")
            el-checkbox(
              v-for="(category, index) in categories",
              :key="index",
              :label="category.cateSeq",
              border) {{ category.cateName }}
      section.form-section
        h2.form-section-title 담당자 정보
        el-form-item(label="이름", prop="contactName")
          .form-group
            el-input(placeholder="이름", v-model="form.contactName")
        el-form-item(label="직급 / 직책", prop="contactDuty")
          .form-group
            el-input(placeholder="직급 / 직책", v-model="form.contactDuty")
        el-form-item(label="이메일", prop="contactEmail")
          .form-group
            el-input(placeholder="이메일", type="email", v-model="form.contactEmail")
          .append-group
            p.input-hint 해당 이메일로 비밀번호 찾기가 발송됩니다.
        el-form-item(label="유선 전화", prop="contactPhone")
          .form-group
            el-input(placeholder="유선 전화", v-model="form.contactPhone", type="number", maxlength="8")
              el-select(slot="prepend", v-model="phonePrefix")
                el-option(label="02", value="02")
                el-option(label="031", value="031")
                el-option(label="032", value="032")
                el-option(label="033", value="033")
                el-option(label="041", value="041")
                el-option(label="042", value="042")
                el-option(label="043", value="043")
                el-option(label="051", value="051")
                el-option(label="052", value="052")
                el-option(label="053", value="053")
                el-option(label="054", value="054")
                el-option(label="055", value="055")
                el-option(label="061", value="061")
                el-option(label="062", value="062")
                el-option(label="063", value="063")
                el-option(label="064", value="064")
                el-option(label="070", value="070")
                el-option(label="030", value="030")
                el-option(label="050", value="050")
                el-option(label="060", value="060")
                el-option(label="080", value="080")
                el-option(label="0502", value="0502")
                el-option(label="0503", value="0503")
                el-option(label="0504", value="0504")
                el-option(label="0505", value="0505")
                el-option(label="0507", value="0507")
                el-option(label="010", value="010")
                el-option(label="011", value="011")
                el-option(label="016", value="016")
                el-option(label="017", value="017")
                el-option(label="018", value="018")
                el-option(label="019", value="019")
        el-form-item(label="휴대 전화", prop="contactMobile")
          .form-group
            el-input(placeholder="휴대 전화", v-model="form.contactMobile", type="number", maxlength="8")
              el-select(slot="prepend", v-model="mobilePrefix")
                el-option(label="010", value="010")
                el-option(label="011", value="011")
                el-option(label="016", value="016")
                el-option(label="017", value="017")
                el-option(label="018", value="018")
                el-option(label="019", value="019")
      .submit-button-wrapper
        el-button.submit-button(type="info", @click="submit") 작성완료
</template>

<script>
import ScFileInput from '@/components/ScFileInput.vue';
import { mapState } from 'vuex';
import _ from 'lodash';

export default {
  components: {
    ScFileInput,
  },
  async mounted() {
    // 사업자 번호가 없을 경우
    if (this.$store.state.companyNumber === null) {
      this.$router.replace('/register/terms');
    } else {
      this.form.companyNumber = this.$store.state.companyNumber;
    }

    const women = await this.$http.get('/api/comm/v1/store-categories', { params: { gndr: 'F', ctyp: 'S' } });
    this.womenCategories = women.data.data;

    const men = await this.$http.get('/api/comm/v1/store-categories', { params: { gndr: 'M', ctyp: 'S' } });
    this.menCategories = men.data.data;

    const brand = await this.$http.get('/api/comm/v1/brand-categories', { params: { ctyp: 'S' } });
    this.brandCategories = brand.data.data;
  },
  computed: {
    ...mapState({
      companyNumber: state => state.companyNumber,
    }),
  },
  data() {
    // 아이디 체크
    const validateId = (rule, value, callback) => {
      if (value === '' || value === null) {
        callback(new Error('아이디를 입력하세요.'));
      } else if (!this.isIdDuplicated) {
        callback(new Error('중복체크를 확인하세요.'));
      }
      callback();
    };

    // 비밀번호 체크
    const validatePasswd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('비밀번호를 다시 입력하세요.'));
      } else if (this.form.passwdValidator !== '') {
        this.$refs.formRef.validateField('passwdValidator');
      }
      callback();
    };
    const validatePasswdValidator = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('비밀번호확인을 다시 입력하세요.'));
      } else if (value !== this.form.passwd) {
        callback(new Error('비밀번호 확인과 다릅니다.'));
      }
      callback();
    };

    // 쇼핑몰 명 체크
    const validateStoreName = async (rule, value, callback) => {
      try {
        await this.$http.get('/api/mkc/v1/check-store-name', { params: { name: value } });
        callback();
      } catch (e) {
        callback(new Error(e.response.data.message));
      }
    };

    // 웹 도메인 체크
    const validateStoreDomain = async (rule, value, callback) => {
      try {
        await this.$http.get('/api/mkc/v1/check-store-domain', { params: { domain: value } });
        callback();
      } catch (e) {
        callback(new Error(e.response.data.message));
      }
    };

    // 모바일 도메인 체크
    const validateStoreMobDomain = async (rule, value, callback) => {
      try {
        await this.$http.get('/api/mkc/v1/check-store-mob-domain', { params: { domain: value } });
        callback();
      } catch (e) {
        callback(new Error(e.response.data.message));
      }
    };

    // 호스팅사 체크
    const validateHostingEtc = (rule, value, callback) => {
      if (this.form.hostingCode === '99' && (value === '' || value === null)) {
        callback(new Error('호스팅사를 입력해주세요.'));
      }
      callback();
    };

    const validateCategorySeqs = (rule, value, callback) => {
      if (this.form.shopType === '1' && value.length > 2) {
        this.form.cateSeqs = _.slice(value, 0, 2);
        this.$message.error('2개의 카테고리만 선택 하실수 있습니다.');
      } else if (this.form.shopType === '2' && value.length > 1) {
        this.form.cateSeqs = _.slice(value, 0, 1);
        this.$message.error('1개의 카테고리만 선택 하실수 있습니다.');
      }
      callback();
    };

    return {
      form: {
        companyNumber: null,
        id: null,
        passwd: '',
        passwdValidator: '',
        companyName: null,
        presidentName: null,
        storeName: null,
        storeDomain: null,
        storeMobDomain: null,
        hostingCode: null,
        hostingEtc: null,
        nvEpTotalUrl: null,
        licenseFile: null,
        licenseFileName: null,
        shopType: null,
        storeType: null,
        storeGender: null,
        cateSeqs: [],
        ageGroup10: false,
        ageGroup20: false,
        ageGroup30: false,
        ageSeqs: [],
        contactName: null,
        contactDuty: null,
        contactEmail: null,
        contactPhone: null,
        contactMobile: null,
      },
      // TODO: 필수필드나 필드별로 제한이 있는 것들에 대한 정보가 필요함.
      rules: {
        id: [
          {
            min: 4, max: 20, message: '아이디는 4~20자로 입력해 주세요.', trigger: 'blur',
          },
          { validator: validateId, trigger: 'blur' },
        ],
        passwd: [
          { validator: validatePasswd, trigger: 'blur' },
        ],
        passwdValidator: [
          { validator: validatePasswdValidator, trigger: 'blur' },
        ],
        companyName: [
          { required: true, message: '기업명을 입력해 주세요.', trigger: 'blur' },
        ],
        presidentName: [
          { required: true, message: '대표자명을 입력해 주세요.', trigger: 'blur' },
        ],
        cateSeqs: [
          { validator: validateCategorySeqs, trigger: 'change' },
        ],
        storeName: [
          { required: true, message: '쇼핑몰명을 입력해 주세요.', trigger: 'blur' },
          {
            min: 1, max: 30, message: '쇼핑몰명은 1~30자까지 입력이 가능 합니다.', trigger: 'blur',
          },
          { validator: validateStoreName, trigger: 'blur' },
        ],
        storeDomain: [
          { required: true, message: '웹 도메인을 입력해 주세요.', trigger: 'blur' },
          {
            min: 1, max: 60, message: '웹 도메인은 60자까지 입력이 가능 합니다.', trigger: 'blur',
          },
          { validator: validateStoreDomain, trigger: 'blur' },
        ],
        storeMobDomain: [
          {
            min: 1, max: 60, message: '모바일 도메인은 60자까지 입력이 가능 합니다.', trigger: 'blur',
          },
          { validator: validateStoreMobDomain, trigger: 'blur' },
        ],
        hostingCode: [
          { required: true, message: '호스팅사를 선택해 주세요.', trigger: 'blur' },
        ],
        hostingEtc: [
          { validator: validateHostingEtc, trigger: 'blur' },
        ],
        licenseFile: [
          { required: true, message: '사업자등록증을 첨부해 주세요.', trigger: 'blur' },
        ],
        shopType: [
          { required: true, message: '쇼핑몰 속성을 선택해 주세요.', trigger: 'blur' },
        ],
        contactName: [
          { required: true, message: '담당자명을 입력해 주세요.', trigger: 'blur' },
        ],
        contactDuty: [
          { required: true, message: '담당자 직급/직책을 입력해 주세요.', trigger: 'blur' },
        ],
        contactEmail: [
          { required: true, message: '담당자 이메일을 입력해 주세요.', trigger: 'blur' },
        ],
        contactPhone: [
          { required: true, message: '담당자 유선전화를 입력해 주세요.', trigger: 'blur' },
        ],
        contactMobile: [
          { required: true, message: '담당자 휴대전화를 입력해 주세요.', trigger: 'blur' },
        ],
      },
      isIdDuplicated: false,
      categories: null,
      womenCategories: null,
      menCategories: null,
      brandCategories: null,
      phonePrefix: '02',
      mobilePrefix: '010',
    };
  },
  methods: {
    // 배열 특정값 삭제
    arrayRemove(array, value) {
      const index = array.indexOf(value);
      if (index !== -1) {
        array.splice(index, 1);
      }
    },

    // URL 입력
    blurUrl(e, type) {
      const url = e.target.value.replace(/(http(s)?:\/\/)/, '').replace(/(^[w]{3})+\./, '');
      if (type === 'web') {
        this.form.storeDomain = url;
      } else if (type === 'mobile') {
        this.form.storeMobDomain = url;
      }
    },

    // 호스팅사 선택
    changeHosting() {
      this.$refs.formRef.validateField('hostingCode');
    },

    // 연령 선택
    changeAge(e, v) {
      const result = this.form.ageSeqs;
      if (e) {
        result.push(v);
      } else {
        this.arrayRemove(result, v);
      }
      this.form.ageSeqs = result;
    },

    // 아이디 중복 체크
    async checkDuplicate() {
      try {
        if (this.form.id === '' || this.form.id === null) {
          this.$refs.formRef.validateField('id');
        } else {
          await this.$http.get('/api/mkc/v1/check-id', { params: { id: this.form.id } });
          this.isIdDuplicated = true;
          this.$refs.formRef.validateField('id');
        }
      } catch (e) {
        if (e.response.status === 409) {
          this.$message.error(e.response.data.message);
        } else {
          this.$message.error(e.response.data.message);
        }
      }
    },

    // 쇼핑몰 속성
    changeShopType() {
      this.form.cateSeqs = [];
      if (this.form.shopType === '1') {
        this.categories = this.womenCategories;
        this.form.storeType = 'S';
        this.form.storeGender = 'F';
      } else if (this.form.shopType === '2') {
        this.categories = this.menCategories;
        this.form.storeType = 'S';
        this.form.storeGender = 'M';
      } else if (this.form.shopType === '3') {
        this.categories = this.brandCategories;
        this.form.storeType = 'B';
        this.form.storeGender = 'A';
      }
      this.$refs.formRef.validateField('shopType');
    },

    // 사업자등록증 첨부
    upload(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.form.licenseFileName = file.name;
      this.form.licenseFile = file;
      this.$refs.formRef.validateField('licenseFile');
    },

    // 작성완료
    async submit() {
      const valid = await this.$refs.formRef.validate();
      if (!valid) {
        this.$message('입력값을 확인해주세요');
      } else if (this.form.storeType !== 'B' && this.form.ageSeqs.length === 0) {
        this.$message('연령대를 선택해 주세요.');
      } else {
        const formdata = new FormData();
        formdata.append('id', this.form.id);
        formdata.append('passwd', this.form.passwd);
        formdata.append('companyNumber', this.form.companyNumber);
        formdata.append('contactName', this.form.contactName);
        formdata.append('contactDuty', this.form.contactDuty);
        if (this.form.contactPhone !== null && this.form.contactPhone !== '') {
          formdata.append('contactPhone', this.phonePrefix + this.form.contactPhone);
        }
        formdata.append('contactMobile', this.mobilePrefix + this.form.contactMobile);
        formdata.append('contactEmail', this.form.contactEmail);
        formdata.append('licenseFile', this.form.licenseFile);
        formdata.append('storeType', this.form.storeType);
        formdata.append('storeGender', this.form.storeGender);
        formdata.append('companyName', this.form.companyName);
        formdata.append('presidentName', this.form.presidentName);
        formdata.append('storeName', this.form.storeName);
        formdata.append('storeDomain', this.form.storeDomain);
        if (this.form.storeMobDomain !== null && this.form.storeMobDomain !== '') {
          formdata.append('storeMobDomain', this.form.storeMobDomain);
        }
        formdata.append('hostingCode', this.form.hostingCode);
        if (this.form.hostingCode === '99') {
          formdata.append('hostingEtc', this.form.hostingEtc);
        }
        if (this.form.nvEpTotalUrl !== null && this.form.nvEpTotalUrl !== '') {
          formdata.append('nvEpTotalUrl', this.form.nvEpTotalUrl);
        }
        formdata.append('ageSeqs', this.form.ageSeqs);
        formdata.append('cateSeqs', this.form.cateSeqs);

        try {
          await this.$http.post('/api/mkc/v1/join', formdata);
          this.$store.commit('setCompanyNumber', null);
          this.$router.replace('/login');
        } catch (e) {
          this.$alert(e.response.data.message, {
            confirmButtonText: '확인',
          });
        }
      }
    },
  },
};
</script>
